import { api } from "@api/api";
import { IntegrationEndpoint } from "@modules/erpIntegrations/types";

import { EditEndpointVariables } from "./types";

export async function editEndpointService({
  id,
  method,
  data,
}: EditEndpointVariables): Promise<IntegrationEndpoint> {
  const { data: endpoint } = await api.request<IntegrationEndpoint>({
    url: `/v1/integration_endpoint_admin/${id}/`,
    method,
    data,
  });

  return endpoint;
}
